import styled from 'styled-components';
import { FullWidth } from 'ui/utility/fullWidth';

/**
 * Table
 * Styled components to create a table
 */
export const Table = styled(FullWidth)``;
